import type { SolverPhasesSelectionModalProps } from "@/components/modals/SolverPhasesSelectionModal.types.tsx";
import { buildSolverPhasesController } from "@/components/sections/SolverPhases.tsx";
import SolverPhasesSelection from "@/components/sections/SolverPhasesSelection.tsx";
import CheckboxField from "@/components/forms/CheckboxField.tsx";
import React, { useEffect, useState } from "react";
import Modal from "./Modal";


/**
 * Main component
 * @param param0
 * @returns
 */
const SolverPhasesSelectionModal: React.FC<SolverPhasesSelectionModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        title,
        confirmLabel = "Fermer",
        cancelLabel = "Annuler",
        showCancelButton = false,
        confirmDisabled = false,
        depConfigs = {},
        dateFilter,
    }) => {

    //const [confirmOpenGlobalSettingModal, setConfirmOpenGlobalSettingModal] = useState(false);
    const [selectedPhaseId, setSelectedPhaseId] = useState<string | undefined>();
    const [applyDateFilter, setApplyDateFilter] = useState(false);
    //const [confirmOpenPhaseModal , setConfirmOpenPhaseModal] = useState(false);
    const ctrl = buildSolverPhasesController(depConfigs, selectedPhaseId, true);
    const viewData = ctrl.viewData;
    //const [editData , setEditData] = useState({...{},...solverConfigs});


    //@ Reset editData each time modal is opened (Not sure if this is the proper way of doing it)
    useEffect(() => {
        if (open) {
            ctrl.setEditData({ ...{}, ...depConfigs });
        }
    }, [open, depConfigs]);

    useEffect(() => {
        if (open) {
            setApplyDateFilter(false);
        }
    }, [open]);

    const handleConfirm = () => {
        onConfirm(viewData.selectedPhaseId, applyDateFilter);
        onClose();
    };


    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title || "Sélection de la phase a résoudre"}
            size="md"
            footer={
                <>
                    {
                        showCancelButton ? <button
                            onClick={onClose}
                            className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            {cancelLabel}
                        </button> : ''
                    }
                    <button
                        onClick={handleConfirm}
                        disabled={confirmDisabled}
                        className={`inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${confirmDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-green-700"}`}
                    >
                        {confirmLabel || "Démarrer"}
                    </button>
                </>
            }
        >
            <SolverPhasesSelection
                // selectGlobalConfig={()=>{setConfirmOpenGlobalSettingModal(true)}}
                // addPhase={()=>{setSelectedPhaseId("");setConfirmOpenPhaseModal(true)}}
                selectPhase={(id) => {
                    setSelectedPhaseId(id);
                }}
                controller={ctrl}
            >
            </SolverPhasesSelection>

            <div className="mt-6 border-t border-gray-200 pt-6 text-gray-700">
                <span className="text-base font-bold">Options</span>
                <CheckboxField
                    label="Activer le filtre de dates"
                    checked={applyDateFilter}
                    onChange={setApplyDateFilter}
                    disabled={!dateFilter}
                    hint={dateFilter ? `(${dateFilter.startDate} à ${dateFilter.endDate})` : undefined}
                />
            </div>

        </Modal>
    );
};

export default SolverPhasesSelectionModal;
